import { Component, Input } from '@angular/core';

@Component({
    selector: 'azavista3-back-to-list',
    templateUrl: 'back-to-list.component.html',
    standalone: false
})
export class BackToListComponent {
    @Input() link: string;
    @Input() queryParams: Record<string, string>;
    @Input() text = 'BACK_TO_LIST';
}
